module.exports = __webpack_public_path__ + "img/des_tuse_2.6801b69b.jpg";